import { css } from "styled-components";

const colors = {
	// 메인 색상
	mainColor: "#0bd5b8",
	subColor: "#00b8c3",
	subDarkColor: "#212b38",
	pointColor: "#ffac60",
	orangeGradientColor: "#fa9f1c",
	yellowGradientColor: "#ffbe61",
	blackColor: "#323232",
	gray70Color: "#646464",
	gray60Color: "#767676",
	gray50Color: "#939393",
	gray30Color: "#ccc",
	gray20Color: "#E3E3E3",
	navyColor: "#37465b",
	errorColor: "#ff006f",
	bgColor: "#fbfbfb",
};

const breakpoints = {
	lessMobile: "390px",
	mobile: "758px",
	tablet: "1024px",
	desktop: "1025px",
};

const layout = {
	defaultMaxWidth: "1216px",
	defaultDesktopPadding: "40px",
	defaultMobilePadding: "20px",
};

const media = {
	lessMobile: `screen and (max-width: ${breakpoints.lessMobile})`,
	mobile: `screen and (max-width: ${breakpoints.mobile})`,
	tablet: `screen and (max-width: ${breakpoints.tablet})`,
	desktop: `screen and (min-width: ${breakpoints.tablet}`,
};

const commonHeadingStyles = css`
	line-height: ${({ lineHeight }) => lineHeight ?? "1.4"};
	color: ${({ color }) => color ?? colors.navyColor};
	b {
		color: ${colors.mainColor};
	}
`;

const theme = {
	...colors,
	...layout,
	...media,
	commonHeadingStyles,
};

export default theme;
